export default __webpack_public_path__ + "static/logo-4a59f1e1f978daca339a4e17f8f11df3.svg";